import React from 'react';

import QuotaSede  from 'components/Tvendo/Sale/QuotaBPartner/Verdum/QuotaSede/List.js';

export default function () {
  return <QuotaSede  />;
}